import React from 'react';
import { useTranslation } from "react-i18next";
import './ParentARMBoxes.scss';
import ParentARMBox from './ParentARMBox';
import getLatestARMBox from '../../../util/getLatestARMBox';
import { useSelector } from 'react-redux';
import { ARMFloorTooltipContent, isBehind } from '../../../blocks/ARMFloor';
import { locales } from '../../../../../constants/constants';

// group of three ParentARMBoxes, with ARM description
export default function ParentARMBoxes(props) {
  const {armBoxes, studentName, armBoxRefs} = props;
  const selectedLocale = useSelector(state => state?.reports?.teacher?.selectedLocale || "EN-US")

  const { t } = useTranslation(["teacher_parent_report"]);

  const windows = ['BOY', 'MOY', 'EOY'];

  const latestARMBox = getLatestARMBox(armBoxes);
  const {armScore, metric, percentile, benchmarkGrade} = latestARMBox;

  const scoreString = armScore?.toString();
  const leftScore = scoreString?.split(".")[0];
  const rightScore = scoreString?.split(".")[1];
  const currentGradeString = t(`a ${leftScore} grade`);
  const nextGradeString = t(`a ${parseInt(leftScore)+1} grade`);
  const rightScoreTensDigit = rightScore?.[0] || "0";
  const rightScoreDescription = t(`${rightScoreTensDigit} month`);
  const tContext = {
    leftScore,
    rightScore,
    currentGradeString,
    nextGradeString,
    rightScoreDescription,
    studentName,
    interpolation: { escapeValue: false },
  };

  const shouldShowBehindTips = isBehind(percentile, metric, benchmarkGrade, selectedLocale);
  const armFloorDescription = ARMFloorTooltipContent({firstName: studentName});
  
  // English ARM and Spanish ARM have different description contents, each has their translated version into for both languages.
  // This is controlled by the selectedLocale, which is the activity data language, not the display language.
  const leftDescription = selectedLocale === "EN-US" ? "left_score_description" : "left_score_description_spanish_arm";
  const rightDescription = selectedLocale === "EN-US" ? "right_score_description" : "right_score_description_spanish_arm";

  return (
    <>
      {metric === 'ARM' && <div className={`parent-ARM-descriptions-container ${latestARMBox.window}`}>
        <div className='parent-ARM-descriptions'>
          {!shouldShowBehindTips && <><div className='parent-ARM-description'>{t(leftDescription, tContext)}</div>
          <div className='parent-ARM-description'>{t(rightDescription, tContext)}</div></>}
          {shouldShowBehindTips && <div className='parent-ARM-description'>{armFloorDescription}</div>}
        </div>
      </div>}
      <div className='parent-ARM-boxes'>
        {windows.map(window => 
          <ParentARMBox 
            armBoxRefs={armBoxRefs}
            key={window}
            armBox={armBoxes[window]}
            benchmarkGrade={benchmarkGrade}
            selectedLocale={selectedLocale}
            shouldShowBehindTips={shouldShowBehindTips}
            isLatestARMBox={window === latestARMBox.window}
          />
        )}
      </div>
    </>
  )
}
